import { render, staticRenderFns } from "./AppTextarea.vue?vue&type=template&id=a3c1b77c"
import script from "./AppTextarea.vue?vue&type=script&lang=ts"
export * from "./AppTextarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports